import { useRef } from "react";

import { css, keyframes } from "styled-components/macro";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

// Opacity only: the toolbar must not animate its width when the view flips.
export const fadeInOnSwitch = css`
  animation: ${fadeIn} var(--duration-short) var(--ease);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/** True once the view has been switched, so the first paint does not fade. */
export const useSwitched = (monthlyView: boolean) => {
  const previous = useRef(monthlyView);
  const switched = useRef(false);
  if (previous.current !== monthlyView) {
    switched.current = true;
    previous.current = monthlyView;
  }
  return switched.current;
};
